import React from "react";
import PropTypes from "prop-types";
import {
    MdOutlineKeyboardDoubleArrowUp,
    MdOutlineKeyboardDoubleArrowDown,
} from "react-icons/md";

import Money from "../../../components/Money";

/**
 * Totals strip — five-up summary card across the top of the player
 * roster. Mirrors `.sg-totals` in the mockup.
 */
export function GameTotals({ game }) {
    const playerCount = game.players?.length ?? 0;
    const netClass =
        game.totalNet > 0 ? "is-up" : game.totalNet < 0 ? "is-down" : "balanced";

    return (
        <div className="ledger-totals">
            <Tot label="Players">{playerCount}</Tot>
            <Tot label="Buy-ins">
                <Money amount={game.totalBuyIns} />
            </Tot>
            <Tot label="Cash-outs">
                <Money amount={game.totalCashOuts} />
            </Tot>
            <Tot label="Net" valueClass={netClass}>
                <Money amount={game.totalNet} signed={game.totalNet !== 0} />
            </Tot>
        </div>
    );
}

const Tot = ({ label, valueClass = "", children }) => (
    <div className="ledger-tot">
        <div className="ledger-tot-l">{label}</div>
        <div className={`ledger-tot-v ${valueClass}`.trim()}>{children}</div>
    </div>
);

GameTotals.propTypes = { game: PropTypes.object };

/**
 * Column headers for the player roster, with click-to-sort on
 * Buy-in / Cash-out / Net. The first cell is left empty to align
 * with the player avatar column.
 */
export function RosterHeader({ sort, onSort }) {
    const colClass = (key) => {
        const classes = ["right", "sortable", `col-${slug(key)}`];
        if (sort.sortBy === key) classes.push("active");
        return classes.join(" ");
    };

    return (
        <div className="roster-head">
            <span />
            <span>Player</span>
            <span className={colClass("buyIn")} onClick={() => onSort("buyIn")}>
                <SortArrow active={sort.sortBy === "buyIn"} order={sort.sortOrder} />
                Buy-in
            </span>
            <span className={colClass("cashOut")} onClick={() => onSort("cashOut")}>
                <SortArrow active={sort.sortBy === "cashOut"} order={sort.sortOrder} />
                Cash-out
            </span>
            <span className={colClass("net")} onClick={() => onSort("net")}>
                <SortArrow active={sort.sortBy === "net"} order={sort.sortOrder} />
                Net
            </span>
            <span className="right" />
        </div>
    );
}

const SortArrow = ({ active, order }) => {
    if (!active) return null;
    const Icon =
        order === "asc"
            ? MdOutlineKeyboardDoubleArrowDown
            : MdOutlineKeyboardDoubleArrowUp;
    return (
        <span className="arrow" aria-hidden="true">
            <Icon />
        </span>
    );
};

const slug = (s) => s.replace(/([A-Z])/g, "-$1").toLowerCase();

RosterHeader.propTypes = {
    sort: PropTypes.object,
    onSort: PropTypes.func,
};
